import PropTypes from "prop-types";
import React from "react";
import { Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import CreateErrorTaxDeduct from "./CreateErrorTaxDeduct";
import "./style.scss";
import { MODE } from "./utils";

const DetailDataModalV2 = props => {
  const { isOpen, toggle, detailData, isTaxDeduct = false } = props;

  const isCreate = detailData === null;
  return (
    <Modal
      size="xl"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      style={{ maxWidth: "80%" }}
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          <Label>
            {isTaxDeduct
              ? `${
                  isCreate
                    ? "Tạo"
                    : detailData?.mode === MODE.VIEW
                    ? "Chi tiết"
                    : "Cập nhật"
                } thông báo chứng từ sai sót`
              : "Thông báo hóa đơn sai sót"}
          </Label>
        </ModalHeader>
        <ModalBody>
          <CreateErrorTaxDeduct
            isTaxDeduct={isTaxDeduct}
            detailData={detailData}
            toggleDetail={toggle}
          />
        </ModalBody>
        <ModalFooter></ModalFooter>
      </div>
    </Modal>
  );
};

DetailDataModalV2.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  detailData: PropTypes.any,
  isTaxDeduct: PropTypes.bool,
};

export default DetailDataModalV2;
